export enum CreativeTagEvent {
  CREATIVE_INIT = 'creativeInit',
  CREATIVE_REQUESTED = 'creativeRequested',
  CREATIVE_LOADED = 'creativeLoaded',
  CREATIVE_LOADING_FAILED = 'creativeLoadingFailed',
  CREATIVE_ASSET_LOAD = 'creativeAssetLoad',
  CREATIVE_DISPLAY = 'creativeDisplay',
  CREATIVE_VIEW = 'creativeView',
  CREATIVE_TIMESPENT = 'creativeTimespent',
  CREATIVE_SHOW = 'creativeShow',
  CREATIVE_CLICKED = 'creativeClicked'
}
